<template>
  <div></div>
</template>

<script>
export default {
  name: '401'
};
</script>

<style scoped>

</style>
